import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';
import Gsoc2 from '../../../img/Course-Elements/Gsoc2.png'


const Gsoc = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-5xl font-semibold my-4'>GSOC<span className='text-orange-400'>Crash Course</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 2699</h1>
            <h2 className=''>A global, online initiative called "Google Summer of Code" aims to attract fresh developers of open source software.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Should you take GSOC Crash Course?</h1>
                    <h1 className='text-2xl my-2'>Stipend:</h1>
                    <p>The stipend has a minimum of 1500 USD and a maximum of 3300 USD. For large-scale projects, we begin with a base amount of 6000 USD and then adjust it in accordance with the PPP value of each nation.</p>
                    <h1 className='text-2xl my-2'>Impact:</h1>
                    <h3>It creates a very good impact on employers.
                    </h3>
                    </div>
                <img className='flex-1' src={Gsoc2} alt="" />
            </div>
            <CourseOperate />
        </div>
    );

};

export default Gsoc;